<template>
    <div class="row row__secondary-block">
        <div class="col-12 col-lg-4" v-if="main.link">
            <SuperLink 
                class="main-noticies__bottom main-noticies__bottom--first" 
                target="_self"
                :href="main.link">
                <p class="noticies__label">
                    <strong v-if="main.hat">{{main.hat}}</strong>
                    <strong v-else-if="main.link && main.link.editorial">{{main.link.editorial.title}}</strong>
                </p>
                <p class="noticies__title noticies__title--blue"><strong>{{main.title}}</strong></p>
                <p class="noticies__subtitle">{{main.subtitle}}</p>
            </SuperLink>
        </div>
        <div class="col-6 col-md-4 col-lg-2" v-for="sm in small.slice(0,4)" :key="sm.id">
            <Small :item="sm" />
        </div>
    </div>
</template>

<script>
import utils from '@/utils'
import Small from '@/components/home/header/Small'
import SuperLink from '@/components/SuperLink'

export default {
    name: 'Secondary',
    props:['main', 'small'],
    components:{Small,SuperLink},
    data() {
        return {
            utils:utils,
        }
    }
}
</script>